import React from 'react'
import { useLocalization } from '@/hooks/localization'
import { leftOrRight } from './utils'

function Selection ({ left, top, width, height, topOffset, currentLeft, currentTop, currentWidth, currentHeight }) {
  return (
    <React.Fragment>
      <SelectionRectangle className='selection' left={left} top={top} width={width} height={height} topOffset={topOffset} showCorner />
      <SelectionRectangle className='selection current' left={currentLeft} top={currentTop} width={currentWidth} height={currentHeight} topOffset={topOffset} />
    </React.Fragment>
  )
}

function SelectionRectangle ({ className, left = 0, top = 0, width = 100, height = 25, topOffset = 0, showCorner = false }) {
  const { rtl } = useLocalization()
  if (top < topOffset || height === 0 || width === 0) {
    return null
  }
  return (
    <div className={className} style={{ top: top - topOffset, ...leftOrRight(rtl, left), width: width, height: height + 1 }}>
      <div className='selection-border selection-border-top' />
      <div className='selection-border selection-border-left' />
      <div className='selection-border selection-border-bottom' />
      <div className='selection-border selection-border-right' />
      {!!showCorner && <div className='selection-border corner' />}
    </div>
  )
}

export {
  Selection
}



// WEBPACK FOOTER //
// ./src/components/report-tables/core/selection.js